// Hover zoom for product images carrying the "image-magnify-hover" class.
// The first mouse move over an image inserts an overlay showing the full-size
// image at `zoomRatio`; the overlay tracks the cursor and is removed when the
// cursor leaves it or it is clicked.

function toggleLoadingSpinner(image) {
  const opener = image.closest('modal-opener');
  const spinner = opener && opener.querySelector('.loading__spinner');
  if (spinner) spinner.classList.toggle('hidden');
}

function moveWithHover(image, overlay, event, zoomRatio) {
  const ratio = image.height / image.width;
  const bounds = event.target.getBoundingClientRect();
  const xPercent = ((event.clientX - bounds.left) / image.clientWidth) * 100;
  const yPercent = ((event.clientY - bounds.top) / (image.clientWidth * ratio)) * 100;

  overlay.style.backgroundPosition = `${xPercent}% ${yPercent}%`;
  overlay.style.backgroundSize = `${image.width * zoomRatio}px`;
}

function createOverlay(image, zoomRatio) {
  const overlay = document.createElement('div');
  overlay.classList.add('image-magnify-full-size');
  overlay.setAttribute('aria-hidden', 'true');
  overlay.style.opacity = '50%';

  const fullSizeImage = new Image();
  fullSizeImage.onload = () => {
    toggleLoadingSpinner(image);
    overlay.style.backgroundImage = `url('${fullSizeImage.src}')`;
    overlay.style.opacity = '100%';
  };
  fullSizeImage.onerror = () => {
    toggleLoadingSpinner(image);
    overlay.remove();
  };
  fullSizeImage.src = image.src;

  toggleLoadingSpinner(image);
  overlay.onclick = () => overlay.remove();
  overlay.onmousemove = (event) => moveWithHover(image, overlay, event, zoomRatio);
  overlay.onmouseleave = () => overlay.remove();
  image.parentElement.insertBefore(overlay, image);

  return overlay;
}

function enableZoomOnHover(zoomRatio) {
  document.querySelectorAll('.image-magnify-hover').forEach((image) => {
    image.onmousemove = (event) => {
      const overlay =
        image.parentElement.querySelector('.image-magnify-full-size') || createOverlay(image, zoomRatio);
      moveWithHover(image, overlay, event, zoomRatio);
    };
  });
}

enableZoomOnHover(2);
